import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  modal: 'data-popup',
  wrapper: 'data-popup-wrapper',
  content: 'data-popup-content',
  close: 'data-popup-close',
}
const qsAll = {
  pageBtns: 'data-page-popup',
}
const state = {
  focusElement: null,
}
export const toggleModal = (
  toggle = true,
  content = null,
  node = null,
  clear = true,
  position = 'center',
  fullHeight = false,
) => {
  if (toggle) {

    if (clear) dom.content.innerHTML = ''
    if (content) dom.content.innerHTML = content
    if (!content && node) dom.content.appendChild(node)
    dom.wrapper.classList.add('popup-content')
    if (position == 'center') {
      dom.wrapper.classList.remove('lg:bottom-0', 'right-0')
      dom.wrapper.classList.add('lg:bottom-auto')
      dom.wrapper.classList.remove('popup-content')
    } else if (position == 'bottom') {
      dom.wrapper.classList.add('lg:bottom-0', 'right-0')
      dom.wrapper.classList.remove('lg:bottom-auto')
    } else if (position == 'right') {
      dom.wrapper.classList.remove('border')
      dom.wrapper.classList.add('border-l')
      dom.wrapper.classList.add('popup-content')
    }
    dom.wrapper.classList.toggle('lg:top-0', fullHeight)
    dom.modal.classList.remove('-z-1')
    dom.modal.classList.remove('opacity-0')
    dom.modal.classList.add('z-full')
    dom.modal.classList.add('opacity-100')
    dom.modal.classList.add('opened')
    
    setTimeout(() => {
      dom.close.focus()
    }, 50)
  } else {

    dom.modal.classList.remove('opened')
    setTimeout(() => {
      if (clear) dom.content.innerHTML = ''
      dom.modal.classList.add('-z-1')
      dom.modal.classList.add('opacity-0')
      dom.modal.classList.remove('z-full')
      dom.modal.classList.remove('opacity-100')

      if(state.focusElement) state.focusElement.focus() // Focus should go back to the element that opened the modal once the modal is closed.
    }, 300)

  }

  document.body.classList.toggle('overflow-hidden', toggle)
}

export const setupPopup = () => {
  cacheDom(dom, qs, qsAll)
  
  window.openPopup = (modalContent, modalNode = null, focusElement=null) => {
    state.focusElement = focusElement
    toggleModal(true, modalContent, modalNode, true, 'center', false)
  }
  window.closePopup = () => {
    toggleModal(false)
  }
  dom.close.addEventListener('click', () => {
    toggleModal(false)
  })
  dom.wrapper.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.modal.addEventListener('click', () => {
    toggleModal(false)
  })
  dom.pageBtns.forEach((pageBtn) => {
    pageBtn.addEventListener('click', (e) => {
      e.preventDefault()

      const pageUrl = pageBtn.getAttribute('data-page-popup')
      if (pageUrl && pageUrl != '') {
        e.stopPropagation()
        e.preventDefault()
        fetch(pageUrl)
          .then((res) => res.text())
          .then((res) => {
            const element = new DOMParser().parseFromString(res, 'text/html')
            const innerHTML = `<div class="page-pop-content p-2.5 lg:p-12">${element.querySelector('.custom-liquid > .container') ? element.querySelector('.custom-liquid > .container').innerHTML : element.getElementById('MainContent').innerHTML}</div>`
            toggleModal(true, innerHTML)
          })
      }
    })
  })
  const searchParams = new URLSearchParams(location.search)
  for (const p of searchParams) {
    const popTrigger = document.querySelector(`#${p[0]}`)
    if (popTrigger && popTrigger.hasAttribute(qsAll.pageBtns)) popTrigger.dispatchEvent(new Event('click'))
  }
  window.addEventListener('keyup', (e) => {
    if(e.key === "Escape") toggleModal(false)
  })
}
